import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { useBookingDetailsStore } from '@/scopes/account/booking-details/infrastructure/useBookingDetailsStore'
import { formatDate } from '@/scopes/account/common/formatters'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import styles from './FullCancellationFreeConfirmationStep.module.css'

export function FullCancellationFreeConfirmationStep() {
  const { formatMessage } = useIntl()
  const locale = useConfiguration('locale')
  const costs = useBookingDetailsStore(state => state.fullCancellationCosts)

  if (costs.status === 'success' && costs.isFreeCancellationAllowed) {
    return (
      <Typography variant="body-m-regular-snug" as="p" className={styles.text}>
        {formatMessage(
          { id: 'booking_details_cancel_booking_full_cancellation_free_sheet_text' },
          { freeCancellationLimitDate: formatDate(costs.freeCancellationLimitDate, locale) },
        )}
      </Typography>
    )
  }

  return null
}
